import { render, staticRenderFns } from "./ResultsMainView.vue?vue&type=template&id=9b312ce6"
import script from "./ResultsMainView.vue?vue&type=script&lang=js"
export * from "./ResultsMainView.vue?vue&type=script&lang=js"
import style0 from "./ResultsMainView.vue?vue&type=style&index=0&id=9b312ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports